const actions = {
  FETCH_INFO_REQUEST: 'search/FETCH_INFO_REQUEST',
  FETCH_INFO_SUCCESS: 'search/FETCH_INFO_SUCCESS',
  FETCH_INFO_FAILURE: 'search/FETCH_INFO_FAILURE',
};

export default actions;
